import React, { useState } from "react";
import { BottomNavigation, BottomNavigationAction } from "@mui/material";
import { Home, Info, DesignServices, ContactMail } from "@mui/icons-material";
import { useMediaQuery } from "@mui/material";

const Topnavbar = () => {
  const isMobile = useMediaQuery("(max-width: 768px)");
  const [value, setValue] = useState(0);
  const [mobileNavActive, setMobileNavActive] = useState(false);

  const toggleMobileNav = () => {
    setMobileNavActive(!mobileNavActive);
  };

  return (
    <>
      {/* 🖥️ Desktop Navbar (md+ screens) */}
      {!isMobile && (
        <header id="header" className="header d-flex align-items-center fixed-top">
          <div className="container-fluid container-xl position-relative d-flex align-items-center">
            <a href="/" className="logo d-flex align-items-center me-auto">
              <img src="logo6.png" alt="Logo" style={{ height: "50px", display: "block" }} />
            </a>

            {/* Navigation Menu */}
            <nav id="navmenu" className={`navmenu ${mobileNavActive ? "mobile-nav-active" : ""}`}>
              <ul className={`${mobileNavActive ? "d-block" : ""}`} style={mobileNavActive ? { height: "60vh" } : {}}  >
                <li><a href="#hero" className="active" onClick={() => setMobileNavActive(false)}><Home />&nbsp;Home</a></li>
                <li><a href="#about" onClick={() => setMobileNavActive(false)}>About</a></li>
                <li><a href="#services" onClick={() => setMobileNavActive(false)}>Services</a></li>
                <li><a href="#contact" onClick={() => setMobileNavActive(false)}>Contact</a></li>
              </ul>

              {/* Mobile Menu Toggle Button */}
              <i 
                className={`mobile-nav-toggle d-xl-none bi ${mobileNavActive ? "bi-x" : "bi-list"}`} 
                onClick={toggleMobileNav}
                style={{ cursor: "pointer", fontSize: "24px", color: "#fff" }}
              ></i>
            </nav>
          </div>
        </header>
      )}

      {/* 📱 Mobile Bottom Navigation */}
      {isMobile && (
        <>
          <div className="text-center p-2" style={{ backgroundColor: "#37517e" }}>
            <img src="logo6.png" alt="" style={{ height: "50px" }} />
          </div>

          <BottomNavigation
            value={value}
            onChange={(event, newValue) => setValue(newValue)}
            showLabels
            sx={{ position: "fixed", bottom: 0, left: 0, right: 0, width: "100%", boxShadow: 3, zIndex: 1000 }}
          >
            <BottomNavigationAction label="Home" icon={<Home />} href="#hero" />
            <BottomNavigationAction label="About" icon={<Info />} href="#about" />
            <BottomNavigationAction label="Services" icon={<DesignServices />} href="#services" />
            <BottomNavigationAction label="Contact" icon={<ContactMail />} href="#contact" />
          </BottomNavigation>
        </>
      )}
    </>
  );
};

export default Topnavbar;
